import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { maxScreenWidthForDesktop } from "@/pages/watch/main/constants"

import DesktoView from "@/components/video/videoComments/desktopView";
import "./style.css"
import { addCurrentThemeClassToEle } from '@/utils';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

export default function VideoCommentsView(props: any) {
    const { common } = useLocalTranslation();
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    return (
        <>
            <div className={`videoCommentsView ${addCurrentThemeClassToEle(currentTheme, 'videoCommentsView')} `}>
                {props.finalIsLoading ? (
                // {true ? ( // testing
                    <div className="animate-pulse commentLoader">
                        <div className="w-40 h-7 commentLoader_gray_300 rounded" />
                        {/* Comment input */}
                        <div className="flex items-center gap-2 mt-4">
                            <div className="h-10 w-10 commentLoader_gray_300 rounded-full" />
                            <div className="flex-1 h-10 commentLoader_gray_300 rounded" />
                        </div>

                        {/* Comment list (1 or 2) */}
                        <div className="space-y-4 mt-4">
                            {[1, 2].map(i => (
                                <div key={i} className="flex gap-2 items-start">
                                    <div className="h-8 w-8 commentLoader_gray_300 rounded-full" />
                                    <div className="flex-1 space-y-2">
                                        <div className="h-3 w-1/2 commentLoader_gray_300 rounded" />
                                        <div className="h-3 w-full commentLoader_gray_300 rounded" />
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                ) : (
                    <>
                        {/* <h1 className='text-[16px] font-bold mb-[13px]'>
                            {common.statusText.comments}
                        </h1> */}

                        {props.screenWidth > maxScreenWidthForDesktop ? (
                            <DesktoView />
                        ) : (
                            <DesktoView />
                            // <>mobileview</>
                        )}
                    </>
                )}
            </div>
        </>
    );
}


